import { useNavigate, useSearchParams } from 'react-router'
import { useCallback } from 'react'
import { buildRouterPath } from '../utils/navigation'

/**
 * Custom navigation hook that preserves c_selections parameter
 *
 * Usage:
 *   const navigate = useNavigateWithParams()
 *   navigate('/workflows')  // Will automatically add ?c_selections=...
 */
export function useNavigateWithParams() {
  const reactRouterNavigate = useNavigate()
  const [searchParams] = useSearchParams()

  return useCallback(
    (to: string | number, options?: { replace?: boolean; state?: any; params?: Record<string, string> }) => {
      // Handle numeric navigation (back/forward)
      if (typeof to === 'number') {
        reactRouterNavigate(to)
        return
      }

      // Get additional params from options
      const additionalParams = options?.params || {}

      // Build internal route path with preserved params (NOT a full MFE URL)
      const fullPath = buildRouterPath(to, additionalParams)

      // Navigate with React Router
      reactRouterNavigate(fullPath, {
        replace: options?.replace,
        state: options?.state
      })
    },
    [reactRouterNavigate, searchParams]
  )
}
